export default "/_next/static/images/62d623b3399ad93b9ffe3bdec6bb855f.png";